module.exports = __webpack_public_path__ + "img/Wagon_Back.2cb406a3.svg";